





















import { useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted
} from '@vue/composition-api';
import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import { setErrorFromAxiosError } from '@/utils/helpers';

import { IWorkflow } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { VAutocomplete } from 'vuetify/lib/components';

export default defineComponent({
  name: 'WorkflowAutoCompletePicker',

  props: {
    value: [Array, Number, Object] as PropType<
      IWorkflow | number | (IWorkflow | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    viewAllWorkflows: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const workflowVModel = useVModel(props);

    const store = useStore<IRootState>();

    const { useActions, useGetters } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { getWorkflows, getPublishedWorkflows } = useGetters([
      'getWorkflows',
      'getPublishedWorkflows'
    ]);

    const { fetchWorkflows } = useActions(['fetchWorkflows']);

    const isLoading = ref(false);

    const error = ref<ISystemError | null>(null);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    onMounted(() => {
      isLoading.value = true;

      fetchWorkflows()
        .catch(err => {
          error.value = setErrorFromAxiosError(err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    });

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      workflowVModel,
      getWorkflows,
      getPublishedWorkflows,
      isLoading,
      errorMessageList
    };
  }
});
